export default "__VITE_ASSET__8e0af139__"